import { useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import storage from "../../util/storage";
import ROUTES from "../../constants/routes";
import { formatDataDeletionWarningBannerMessage } from "../../constants/commonConstants";

import "./AccountIssueBanner.scss";

// Persistent (not an auto-disappearing toast), dismissible-per-issue banner
// under the header - Chris's own distinction: dismissing THIS warning
// shouldn't silently suppress a later, more urgent one. Dismissal is stored
// keyed by the exact stage value, so advancing from the 60-day warning to
// the 30-day warning re-shows the banner even though the 60-day one was
// already dismissed - same "reset on new threshold" logic the backend sweep
// itself uses for dataDeletionWarningStage.
const DISMISSED_STAGE_KEY = "dataDeletionWarningDismissedStage";

const AccountIssueBanner = () => {
  const authReducer: any = useSelector((state: any) => state?.AuthReducer);
  const stage: number | null =
    authReducer?.accountRecord?.dataDeletionWarningStage ?? null;

  const [dismissedStage, setDismissedStage] = useState<number | null>(() => {
    const stored = storage.get(DISMISSED_STAGE_KEY);
    return stored ? Number(stored) : null;
  });

  if (stage == null || stage === dismissedStage) {
    return null;
  }

  const handleDismiss = () => {
    storage.set(DISMISSED_STAGE_KEY, String(stage));
    setDismissedStage(stage);
  };

  // Short and link-out on purpose - there's no room here to explain WHY
  // (Base Jump only shows 30 days, but a 90-day grace period exists behind
  // that), so the banner just flags it and sends them to Settings, which
  // has the room for the real explanation. Uses the account's real
  // dataDeletionDate (not the stage-derived relative clause) so the banner
  // states the actual date, matching the Settings row's own treatment.
  const message = formatDataDeletionWarningBannerMessage(
    authReducer?.accountRecord?.dataDeletionDate ?? null
  );
  const settingsRoute = ROUTES.SETTINGS.replace(":id", "");

  return (
    <div className="account-issue-banner">
      <p>
        {message} <Link to={settingsRoute}>See why</Link> or{" "}
        <Link to={settingsRoute}>Upgrade now</Link> to unlock.
      </p>
      <button
        type="button"
        className="account-issue-banner-dismiss"
        onClick={handleDismiss}
        aria-label="Dismiss"
      >
        &times;
      </button>
    </div>
  );
};

export default AccountIssueBanner;
